import { configureStore } from '@reduxjs/toolkit'
import userSlice from 'modules/user/services/Redux/userSlice';
import catalogsSlice from 'modules/bussiness_logic/services/Redux/catalogsSlice';

export const store = configureStore({
  reducer: {
    user: userSlice,
    catalogs: catalogsSlice, 
  }
})